export default __webpack_public_path__ + "static/981-fb45e2127d6a63e8d4268487113f4d3b.gif";